export enum ContactType {
  Email = 'email',
  MobileNumber = 'mobile',
  PhoneNumber = 'phone',
  Custom = 'custom',
  Whatsapp = 'whatsapp'
}

export interface Contact {
  type: ContactType
  value: string
  id?: number
}
